import React from 'react';
import CRUDList from '../Common/CRUDList';
import { agents } from '../../services/api';

const agentStatuses = { 0: 'Closed', 1: 'Active' };
const agentStatusColors = { 0: 'badge-danger', 1: 'badge-success' };

function AgentForm({ formData, setFormData }) {
  return (
    <>
      <div className="form-group">
        <label>Agent Name *</label>
        <input
          type="text"
          value={formData.agent_name || ''}
          onChange={(e) => setFormData({ ...formData, agent_name: e.target.value })}
          required
        />
      </div>

      <div className="form-group">
        <label>Status *</label>
        <select
          value={formData.agent_status ?? 1}
          onChange={(e) => setFormData({ ...formData, agent_status: parseInt(e.target.value) })}
          required
        >
          <option value="1">Active</option>
          <option value="0">Closed</option>
        </select>
      </div>

      <div className="form-group">
        <label>Website</label>
        <input
          type="url"
          value={formData.agent_web || ''}
          onChange={(e) => setFormData({ ...formData, agent_web: e.target.value || null })}
          placeholder="https://example.com"
        />
      </div>
    </>
  );
}

function AgentsList() {
  return (
    <CRUDList
      title="Booking Agents"
      api={agents}
      columns={['ID', 'Agent Name', 'Status', 'Website']}
      FormComponent={AgentForm}
      defaultFormData={{ agent_name: '', agent_status: 1, agent_web: '' }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.agent_id}</td>
          <td>{item.agent_name}</td>
          <td>
            <span className={`badge ${agentStatusColors[item.agent_status]}`}>
              {agentStatuses[item.agent_status]}
            </span>
          </td>
          <td>
            {item.agent_web ? (
              <a href={item.agent_web} target="_blank" rel="noopener noreferrer">
                {item.agent_web}
              </a>
            ) : '-'}
          </td>
        </>
      )}
    />
  );
}

export default AgentsList;
